import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector, useStore } from 'react-redux';

import {
  selectCanFetchAuthenticatedApi,
  selectIsAuthenticated
} from './selectors/authSelectors';
import type { AppDispatch, AppStore, RootState } from './index';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => AppStore = useStore;

export const useIsAuthenticated = (): boolean =>
  useAppSelector(selectIsAuthenticated);

export const useCanFetchAuthenticatedApi = (): boolean =>
  useAppSelector(selectCanFetchAuthenticatedApi);
